// import Logger from './logger';
export default function getFromBreadcrumbs(source, breadcrumbs) {
  const bc = breadcrumbs.split('.');
  let value = null;

  for (let i = 0; i < bc.length; i += 1) {
    const val = bc[i];

    if (i === 0) {
      if (val in source) {
        value = source[val];
      } else {
        // @if TARGET!='prod'
        // Logger.warn(`"${val}" not found in ${source}.`);
        // @endif
        break;
      }
    } else if (val in value) {
      value = value[val];
    } else {
      // @if TARGET!='prod'
      // Logger.warn(`"${val}" not found in value.`);
      // @endif
      break;
    }
  }

  return value;
}
